/**
 * Class description
 *
 * Created: 2019-08-22
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";


export class MysterySymbolReveal implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _tl:TimelineLite;
    private _aborted:boolean = false;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:WinterHoardParsedGameData):void {
       //if(data.mysterySymbolPositions.length > 0) {
           //debugger;
            this._aborted = false;
           WinterHoardGameModuleConfig.mysterySymbolRevealView.prepare(data.mysterySymbolPositions, data.mysterySymbolRevealed);
       //}
    }

    public getAnimation(data:WinterHoardParsedGameData):Timeline | null {
        if(!this._aborted && data.mysterySymbolAppearing || data.shamanspinTriggered) {
            this._tl = new TimelineLite();
            let duration:number = 1.3;
            this._tl.add(() => {
                if(!this._aborted) {
                    duration = WinterHoardGameModuleConfig.mysterySymbolRevealView.getRevealAnimation().totalDuration();
                    //console.log(duration);
                    this._aborted = true;
                }
            });
            this._tl.add(() => {}, duration);
            return this._tl;
        }
        return null;
    }

    public abort(isActive:boolean, data:ParsedServerData):Timeline {
        this._tl.timeScale(2);
        return this._tl;
    }
}